export default interface Tag {
    name: string;
    value: string;
}

export const TagTypes = {
    CUSTOMER_TYPE: 'customerType',
};
